import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth/contexte';
import { Charpente } from './composants/Charpente';
import { Accueil } from './pages/Accueil';
import { Connexion } from './pages/Connexion';
import { MotDePasse } from './pages/MotDePasse';
import { JournalAudit } from './pages/JournalAudit';
import { Clients } from './pages/Clients';
import { FicheClient } from './pages/FicheClient';
import { Mandats } from './pages/Mandats';
import { FicheMandat } from './pages/FicheMandat';
import { Allocations } from './pages/Allocations';
import { Tresorerie } from './pages/Tresorerie';
import { FicheTresorerie } from './pages/FicheTresorerie';
import { Proposition } from './pages/Proposition';
import { Ordres } from './pages/Ordres';
import { Paniers } from './pages/Paniers';
import { FichePanier } from './pages/FichePanier';
import { Campagnes } from './pages/Campagnes';
import { SortiesFonds } from './pages/SortiesFonds';
import { FicheCampagne } from './pages/FicheCampagne';
import { Portefeuille } from './pages/Portefeuille';
import { ImportCours } from './pages/ImportCours';
import { ImportSituation } from './pages/ImportSituation';
import { Reporting } from './pages/Reporting';
import { Releve } from './pages/Releve';
import { Controle } from './pages/Controle';
import { FicheAllocation } from './pages/FicheAllocation';
import { Instruments } from './pages/referentiels/Instruments';
import { Profils } from './pages/referentiels/Profils';
import { Tranches } from './pages/referentiels/Tranches';
import { Agences } from './pages/referentiels/Agences';
import { Indices } from './pages/referentiels/Indices';

function Protege({ children }: { children: React.ReactNode }) {
  const { profil, chargement } = useAuth();

  if (chargement) return null;
  if (!profil) return <Navigate to="/connexion" replace />;
  // Le changement de mot de passe initial est imposé : aucun écran métier
  // n'est accessible tant qu'il n'est pas fait (doc 03, § 7).
  if (profil.doitChangerMotDePasse) return <Navigate to="/mot-de-passe" replace />;

  return <>{children}</>;
}

export function App() {
  const { profil, chargement } = useAuth();

  return (
    <Routes>
      <Route
        path="/connexion"
        element={chargement ? null : profil ? <Navigate to="/" replace /> : <Connexion />}
      />
      <Route
        path="/mot-de-passe"
        element={chargement ? null : profil ? <MotDePasse /> : <Navigate to="/connexion" replace />}
      />
      <Route
        element={
          <Protege>
            <Charpente />
          </Protege>
        }
      >
        <Route path="/" element={<Accueil />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/clients/:id" element={<FicheClient />} />
        <Route path="/mandats" element={<Mandats />} />
        <Route path="/mandats/:id" element={<FicheMandat />} />
        <Route path="/tresorerie" element={<Tresorerie />} />
        <Route path="/mandats/:id/proposition" element={<Proposition />} />
        <Route path="/mandats/:id/portefeuille" element={<Portefeuille />} />
        <Route path="/mandats/:id/tresorerie" element={<FicheTresorerie />} />
        <Route path="/import-cours" element={<ImportCours />} />
        <Route path="/import-situation" element={<ImportSituation />} />
        <Route path="/reporting" element={<Reporting />} />
        <Route path="/ordres" element={<Ordres />} />
        <Route path="/paniers" element={<Paniers />} />
        <Route path="/paniers/:id" element={<FichePanier />} />
        <Route path="/sorties-fonds" element={<SortiesFonds />} />
        <Route path="/campagnes" element={<Campagnes />} />
        <Route path="/campagnes/:id" element={<FicheCampagne />} />
        <Route path="/allocations" element={<Allocations />} />
        <Route path="/allocations/:id" element={<FicheAllocation />} />
        <Route path="/referentiels/instruments" element={<Instruments />} />
        <Route path="/referentiels/profils" element={<Profils />} />
        <Route path="/referentiels/indices" element={<Indices />} />
        <Route path="/referentiels/tranches" element={<Tranches />} />
        <Route path="/referentiels/agences" element={<Agences />} />
        <Route path="/journal-audit" element={<JournalAudit />} />
        <Route path="/controle-coherence" element={<Controle />} />
      </Route>
      {/* Relevé imprimable : page autonome, hors chrome de l'application. */}
      <Route
        path="/releve/:id"
        element={
          <Protege>
            <Releve />
          </Protege>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
